module.exports = __webpack_public_path__ + "img/downloaded_ic.6cd54993.svg";